import { apolloClinicNewLink } from 'graphql/apollo';
import { useMedicalCategoryPropertiesByIdLazyQuery } from 'graphql/generated/graphql';
import { IdParam, MedicalCategoryProperty } from 'model/graphql';
import React, { useEffect, useState } from 'react';

interface IMedicalCategoryPropertyDictionary {
  [key: string]: MedicalCategoryProperty[];
}

interface IMedicalCategoryPropertyContext {
  medicalCategoryPropertyDictionary?: IMedicalCategoryPropertyDictionary;
  fetchMedicalCategoryProperties?: (idParam: IdParam) => boolean; // true:GQL로 요청됨 / false:이미 fetch해 온 데이터가 있어서 요청 하지 않음 -> 바로 접근
  openLocationPickerModal?: boolean;
  setOpenLocationPickerModal?: (open: boolean) => void;
}

const MedicalCategoryPropertyContext = React.createContext<IMedicalCategoryPropertyContext>({});

const MedicalCategoryPropertyProvider = ({ children }: { children: React.ReactNode }) => {
  const [
    medicalCategoryPropertyDictionary,
    setMedicalCategoryPropertyDictionary,
  ] = useState<IMedicalCategoryPropertyDictionary>({});
  const [openLocationPickerModal, setOpenLocationPickerModal] = useState<boolean>(false);

  const [getMedicalCategoryPropertiesByCategoryId, { data }] = useMedicalCategoryPropertiesByIdLazyQuery({
    client: apolloClinicNewLink,
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const id = data?.medicalCategoryById?.id;
    const properties = data?.medicalCategoryById?.medicalCategoryProperties;
    const propertyDictionary = { [id]: properties || null };
    setMedicalCategoryPropertyDictionary({
      ...medicalCategoryPropertyDictionary,
      ...propertyDictionary,
    });
  }, [data]);

  function fetchMedicalCategoryProperties(idParam: IdParam) {
    if (medicalCategoryPropertyDictionary[idParam.id] !== undefined) {
      return false;
    }
    getMedicalCategoryPropertiesByCategoryId({ variables: idParam });
    return true;
  }

  return (
    <MedicalCategoryPropertyContext.Provider
      value={{
        medicalCategoryPropertyDictionary,
        fetchMedicalCategoryProperties,
        openLocationPickerModal,
        setOpenLocationPickerModal,
      }}
    >
      {children}
    </MedicalCategoryPropertyContext.Provider>
  );
};

export { MedicalCategoryPropertyContext, MedicalCategoryPropertyProvider };
